import { useEffect } from 'react';
import axios from 'axios';
import { setEnRouteChargesState } from '../components/guest-map/GuestMapSurface';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Hydrates the global 2/hour en-route ping charge state on mount so
 * the intent modal can be skipped when the guest is already out of
 * charges from an earlier session (rolling 60-minute window across
 * venues). Feeds the GuestMapSurface module-level singleton.
 */
export function useEnRouteChargesBoot() {
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    axios
      .get(`${API}/venues/en-route/status`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setEnRouteChargesState(res.data || {}))
      .catch(() => {});
  }, []);
}
